import { Injectable, Type } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

/**
 * This custom dialog service allows us to set default configuration options
 * for all dialogs opened with PrimeNG's DynamicDialogService.
 */
@Injectable({
  providedIn: 'root',
})
export class CustomDynamicDialogService extends DialogService {
  private _defaultConfig: Partial<DynamicDialogConfig> = {
    modal: true,
    closable: true,
  };

  open<T>(componentType: Type<T>, config: DynamicDialogConfig): DynamicDialogRef<T> {
    // Merge the default config with the provided config
    const mergedConfig = { ...this._defaultConfig, ...config };
    // Workaround for missing draggable class
    if (config.draggable) {
      mergedConfig.styleClass = `${mergedConfig.styleClass ?? ''} p-dialog-draggable`;
    }

    // Call the original open method with the merged config
    return super.open(componentType, mergedConfig);
  }
}
